import { LaborCostDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/LaborCostDashboard/store/laborCostDashboard.store.types';
import {
  OVERTIME_BY_TEAM_MEMBER_TYPE_STUB,
  OVERTIME_HOURS_BY_POSITION_STUB,
  PEAK_CALLOUT_CELLS_STUB,
  RESOLUTION_SPEED_CELLS_STUB,
} from 'pages/ReportsPage/components/AnalyticsDashboards/dataLockedStubData';

const TYPES_OF_HOURS_STUB_ROWS: Array<[string, number, number, number, number]> = [
  ['2026-04-12', 9, 5, 18, 68],
  ['2026-04-14', 11, 6, 16, 72],
  ['2026-04-16', 8, 4, 21, 61],
  ['2026-04-18', 12, 7, 15, 74],
  ['2026-04-20', 10, 5, 19, 66],
  ['2026-04-22', 13, 6, 22, 70],
  ['2026-04-24', 9, 7, 17, 63],
  ['2026-04-26', 11, 4, 20, 71],
  ['2026-04-28', 10, 5, 16, 69],
  ['2026-04-30', 8, 6, 18, 60],
  ['2026-05-02', 12, 4, 21, 73],
  ['2026-05-04', 9, 7, 15, 65],
  ['2026-05-06', 13, 6, 19, 67],
  ['2026-05-08', 10, 5, 17, 74],
  ['2026-05-10', 11, 4, 22, 62],
  ['2026-05-12', 9, 6, 20, 70],
];

export const LABOR_COST_DATA_LOCKED_STUB: Partial<LaborCostDashboardStore> = {
  calloutHours: 17901,
  calloutHoursPeriodDays: 7,
  calloutHoursChangePrct: -5,
  dailyOvertimeHours: 699,
  dailyOvertimeHoursPeriodDays: 7,
  dailyOvertimeHoursChangePrct: 6,
  unfulfilledHours: 2878,
  unfulfilledHoursPeriodDays: 7,
  unfulfilledHoursChangePrct: -3,
  scheduledHours: 133146,
  scheduledHoursPeriodDays: 7,
  scheduledHoursChangePrct: 2,
  typesOfHours: TYPES_OF_HOURS_STUB_ROWS.map(
    ([date, unfulfilledHours, agencyHours, calloutHours, assignedHours]) => ({
      date,
      unfulfilledHours,
      agencyHours,
      calloutHours,
      assignedHours,
    }),
  ),
  calloutTimeframeCells: PEAK_CALLOUT_CELLS_STUB,
  calloutFulfillmentRate: [
    { timeframe: 'Morning', fulfillmentRate: 82 },
    { timeframe: 'Evening', fulfillmentRate: 88 },
    { timeframe: 'Overnight', fulfillmentRate: 70 },
  ],
  resolutionSpeedCells: RESOLUTION_SPEED_CELLS_STUB,
  overtimeByPosition: OVERTIME_HOURS_BY_POSITION_STUB.slice(0, 5),
  overtimeByTeamMemberType: OVERTIME_BY_TEAM_MEMBER_TYPE_STUB,
  dailyOvertimeDetails: [
    {
      day: '04/12/2026',
      location: 'Seasons Amherstburg',
      teamMember: 'Naj Dubois',
      totalDailyWorkingHours: 11.25,
      dailyLimit: 8,
      dailyOvertime: 3.25,
    },
    {
      day: '04/12/2026',
      location: 'Seasons Amherstburg',
      teamMember: 'Saloni Mehra',
      totalDailyWorkingHours: 11.25,
      dailyLimit: 8,
      dailyOvertime: 3.25,
    },
    {
      day: '04/12/2026',
      location: 'Seasons Owen Sound',
      teamMember: 'Stephanie Ellis',
      totalDailyWorkingHours: 11.5,
      dailyLimit: 8,
      dailyOvertime: 3.5,
    },
    {
      day: '04/12/2026',
      location: 'Seasons Cambridge',
      teamMember: 'Angelo Saboo',
      totalDailyWorkingHours: 8.75,
      dailyLimit: 8,
      dailyOvertime: 0.75,
    },
    {
      day: '04/12/2026',
      location: 'Seasons Owen Sound',
      teamMember: 'Jenny Johnson',
      totalDailyWorkingHours: 12,
      dailyLimit: 8,
      dailyOvertime: 4,
    },
  ],
  dailyOvertimeDetailsPage: 1,
  dailyOvertimeDetailsTotalPages: 1,
  weeklyOvertimeDetails: [
    {
      weekStartDate: '04/12/2026',
      location: 'Seasons Wesbrook',
      teamMember: 'Sofia Ortiz Gutierrez',
      totalWeeklyWorkingHours: 44,
      weeklyLimit: 38,
      weeklyOvertime: 6,
    },
    {
      weekStartDate: '04/19/2026',
      location: 'Seasons Arbutus',
      teamMember: 'Ozan Canbolat',
      totalWeeklyWorkingHours: 42.5,
      weeklyLimit: 40,
      weeklyOvertime: 2.5,
    },
    {
      weekStartDate: '05/02/2026',
      location: 'Seasons Arbutus',
      teamMember: 'Katarina Mihajlovic',
      totalWeeklyWorkingHours: 45,
      weeklyLimit: 40,
      weeklyOvertime: 5,
    },
    {
      weekStartDate: '05/03/2026',
      location: 'Seasons Wesbrook',
      teamMember: 'Sofia Ortiz Gutierrez',
      totalWeeklyWorkingHours: 45,
      weeklyLimit: 38,
      weeklyOvertime: 7,
    },
  ],
  weeklyOvertimeDetailsPage: 1,
  weeklyOvertimeDetailsTotalPages: 1,
};
